import { createSlice } from "@reduxjs/toolkit";
import { updatePatientProfile } from "../../apis/setting/updatePatientProfile";

const initialState = {
    loading: false,
    data: null,
    error: null
}

const updatePatientProfileSlice = createSlice({
    name: 'updatePatientProfile',
    initialState,

    extraReducers: (builder) => {
        builder.addCase(updatePatientProfile.pending.type, (state) => {
            return {
                ...state,
                loading: true,
                data: null,
                error: null
            }
        })

        builder.addCase(updatePatientProfile.fulfilled.type, (state, action) => {
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null
            }
        })

        builder.addCase(updatePatientProfile.rejected.type, (state, action) => {
            return {
                ...state,
                loading: false,
                data: null,
                error: action.payload
            }
        })
    }

})

export default updatePatientProfileSlice.reducer